
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pmark",
      function () {
        return require("private-next-pages/pmark/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pmark"])
      });
    }
  